import de from './de.json' with { type: 'json' };
import en from './en.json' with { type: 'json' };

/**
 * The `patterns` namespace (Addendum B.2): shared UI-chrome copy, bundled with the package
 * rather than fetched, so keys and code ship atomically.
 */
export const patternsI18nNamespace = 'patterns' as const;
export const patternsResources = { de, en } as const;
